import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
  useMemo,
} from "react";
import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import {
  ThemeProvider as MUIThemeProvider,
  createTheme,
} from "@mui/material/styles";

interface ThemeColors {
  background: string;
  backgroundGradient: string;
  text: string;
  primary: string;
  cardBackground: string;
  textButton: string;
  iconBackground: string;
  ServicesIconBackground: string;
  icon: string;
  alert: string;
  error: string;
  title: string;
  textSecondary: string;
  textSecondary2: string;
  line: string;
  buttonStroke: string;
  buttonBackground: string;
  navigationBackground: string;
  menuItemBackground: string;
  menuIcon: string;
  supportButtonBackground: string;
  dropdownBorder: string;
  dropdownBackground: string;
  dropdownText: string;
  HairDresserDropdownText: string;
  dropdownActiveBackground: string;
  dropdownSelectedIcon: string;
  dropdownSelectedIconText: string;
  searchBarBackground: string;
  searchIconColor: string;
  searchPlaceholderColor: string;
  headerBackground: string;
  dateBackground: string;
  headerText: string;
  helpPageText: string;
  SpecialPrimary: string;
  helpPageBackground: string;
  topSectionBackground: string;
  availableCardBackground: string;
  availableCardBodyBackground: string;
  availableServiceTitleColor: string;
  availableStylistNameColor: string;
  availableCardFooterBackground: string;
  availableTimeTextColor: string;
  availableShowMoreButtonBackground: string;
  availableShowMoreButtonTextColor: string;
  filterButtonBackground: string;
  filterButtonTextColor: string;
  timesPageSectionBackground: string;
  filterInfoBoxBackground: string;
  filterInfoBoxTextColor: string;
  infoborder: string;
  infoFieldBackground: string;
  infoErrorColor: string;
  infoSubmitButtonBackground: string;
  infoConfirmedBackground: string;
  infoSubmitButtonActiveBackground: string;
  modalOverlayBackground: string;
  modalContentBackground: string;
  modalText: string;
  gradientBackground: string;
  titleTextColor: string;
  DetailAlert: string;
  ServiceItemBG: string;
  primarySVG: string; 
  iconSVG: string; 
  iconInactive: string;
  textInactive: string;
  iconSVGActive: string;
  headerCardBackground: string;
  timeIconColor: string;
  timeTextColor: string;
  pending: string;
  pendingHeader: string;
  pendingFooter: string;
  descriptionPlaceholder: string;
  Servicebackground: string;
  ServiceCardBackground: string;
  ServicebackgroundButton: string;
  HyrDreserTExt: string;
  iconCircleBackground: string;
  success: string; 
  danger: string;  
}

const themeColors: { dark: ThemeColors; light: ThemeColors } = {
  dark: {
    Servicebackground: "#474281",
    ServicebackgroundButton: "#474281",
    descriptionPlaceholder: "#F5EAD5",
    success: "#2ecc71",
    danger: "#e74c3c",
    gradientBackground: "linear-gradient(135deg, #2A1E55, #1A144A)",
    modalOverlayBackground: "rgba(0, 0, 0, 0.5)",
    modalContentBackground: "#474281",
    modalText: "#FFFFFF",
    helpPageText: "#FFFFFF",
    helpPageBackground: "#332F5C",
    headerText: "#FFFFFF",
    background: "#474281",
    backgroundGradient:
      "linear-gradient(to bottom, rgba(0, 0, 0, 0) 85%, #2A1E55 100%)",
    text: "#FFFFFF",
    primary: "#5D50A3",
    SpecialPrimary: "#C8B8F5",
    cardBackground: "#2A1E55",
    textButton: "#4E3DA8",
    iconBackground: "#9B8FCB",
    ServicesIconBackground: "#817BC1",
    icon: "#C8B8F5",
    alert: "#F5EAD5",
    DetailAlert: "#474281",
    error: "#FF0000",
    title: "#FFFFFF",
    textSecondary: "#C5C5C5",
    textSecondary2 : "#fff",
    line: "#5A4D85",
    buttonStroke: "#8978C7",
    buttonBackground: "#6E68AD",
    navigationBackground: "#565096",
    menuItemBackground: "#6E68AD",
    menuIcon: "#fff",
    supportButtonBackground: "#6E68AD",
    dropdownBorder: "#B7AFF7",
    dropdownBackground: "#2A1E55",
    dropdownText: "#FFFFFF",
    HairDresserDropdownText: "#fff",
    dropdownActiveBackground: "#D6CFFF",
    dropdownSelectedIcon: "#998FEE",
    dropdownSelectedIconText: "#FFFFFF",
    searchBarBackground: "#474281",
    searchIconColor: "#C8B8F5",
    searchPlaceholderColor: "#C5C5C5",
    headerBackground: "#332F5C",
    dateBackground: "#332F5C",
    topSectionBackground: "#474281",
    availableCardBackground: "#6E68AD",
    ServiceItemBG: "#565096",
    availableCardBodyBackground: "#6E68AD",
    availableServiceTitleColor: "#FFFFFF",
    availableStylistNameColor: "#C8B8F5",
    availableCardFooterBackground: "#474281",
    availableTimeTextColor: "#FFFFFF",
    availableShowMoreButtonBackground: "#4E3DA8",
    availableShowMoreButtonTextColor: "#FFFFFF",
    filterButtonBackground: "#6E68AD",
    filterButtonTextColor: "#FFFFFF",
    timesPageSectionBackground: "#474281",
    filterInfoBoxBackground: "#2A1E55",
    filterInfoBoxTextColor: "#FFFFFF",
    infoborder: "#C8B8F5",
    infoFieldBackground: "#474281",
    infoErrorColor: "#FF0000",
    infoSubmitButtonBackground: "#695cd5",
    infoConfirmedBackground: "#28a745",
    infoSubmitButtonActiveBackground: "#483d99",
    titleTextColor: "#FFFFFF",
    primarySVG: "#FFFFFF",
    iconSVG: "#ffffff",
    iconInactive: "#474281",
    textInactive: "#C5C5C5",
    iconSVGActive: "#FFFFFF",
    headerCardBackground: "#817BC1",
    timeIconColor: "#FFFFFF",
    timeTextColor: "#FFFFFF",
    pending: "#BBAE6A",
    pendingHeader: "#9B8C53",
    pendingFooter: "#9B8C53",
    ServiceCardBackground: "#6E68AD",
    HyrDreserTExt:  "#332F5C",
    iconCircleBackground: "#D0CBFF",
  },



  light: {
    success: "#28a745",
    danger: "#dc3545",
    iconCircleBackground: "#fff",
    HyrDreserTExt : "#6E68AD",
    ServiceCardBackground: "#fff",
    Servicebackground: "#f4f4f4",
    ServicebackgroundButton: "#D6CFFF",
    descriptionPlaceholder: "#383838",

    pending: "#FFECCC",
    pendingHeader: "#F6DFA8",
    pendingFooter: "#fff",
    timeIconColor: "#332f5c",
    timeTextColor: "#332f5c",
   
    headerCardBackground: "#d6cfff",
    iconSVGActive: "#695CD5",
    primarySVG: "#5D50A3",
    iconSVG: "#5D50A3",
    iconInactive: "#ffffff",
    textInactive: "#9B9B9B",
    gradientBackground: "linear-gradient(135deg, #6a11cb, #2575fc)",
    modalOverlayBackground: "rgba(0, 0, 0, 0.5)",
    modalContentBackground: "#FFFFFF",
    modalText: "#333333",
    infoborder: "#ccc",
    infoFieldBackground: "#fff",
    infoErrorColor: "#FF0000",
    infoSubmitButtonBackground: "#695cd5",
    infoConfirmedBackground: "#28a745",
    infoSubmitButtonActiveBackground: "#483d99",
    headerText: "#333333",
    background: "#FFFFFF",
    backgroundGradient:
      "linear-gradient(to bottom, rgba(255, 255, 255, 0) 85%, #e0e0e0e5 100%)",
    text: "#000000ab",
    primary: "#000000",
    SpecialPrimary: "#4D5389",
    cardBackground: "#FFFFFF",
    textButton: "#444444",
    iconBackground: "#DDDDDD",
    ServicesIconBackground: "#EFEDFF",
    icon: "#888888",
    alert: "#FFECCC",
    DetailAlert: "#FFECCC",
    error: "#FF0000",
    title: "#333333",
    textSecondary2 : "#332F5C",
    textSecondary: "#666666",
    line: "#E4E4E4",
    buttonStroke: "#B7AFF7",
    buttonBackground: "#F4F4F4",
    navigationBackground: "#CCCCCC",
    menuItemBackground: "#F4F4F4",
    menuIcon: "#332F5C",
    supportButtonBackground: "#E5E1FF",
    dropdownBorder: "#B7AFF7",
    dropdownBackground: "#FFFFFF",
    dropdownText: "#4D5389",
    HairDresserDropdownText: "#fff",
    dropdownActiveBackground: "#d6cfff",
    dropdownSelectedIcon: "#695CD5",
    dropdownSelectedIconText: "#FFFFFF",
    searchBarBackground: "#FFFFFF",
    searchIconColor: "#6F42C1",
    searchPlaceholderColor: "#AAAAAA",
    headerBackground: "var(--theme-buttonBackground)",
    dateBackground: "#FFFFFF",
    helpPageText: "#332F5C",
    helpPageBackground: "#FFFFFF",
    topSectionBackground: "#EFEDFF",
    availableCardBackground: "#e5e1ff",
    ServiceItemBG: "#e5e1ff",
    availableCardBodyBackground: "#e5e1ff",
    availableServiceTitleColor: "#332f5c",
    availableStylistNameColor: "#332f5c",
    availableCardFooterBackground: "#fff",
    availableTimeTextColor: "#332f5c",
    availableShowMoreButtonBackground: "#695cd5",
    availableShowMoreButtonTextColor: "#332f5c",
    filterButtonBackground: "#ffffff",
    filterButtonTextColor: "#332f5c",
    timesPageSectionBackground: "#f0f0f0",
    filterInfoBoxBackground: "#ffffff",
    filterInfoBoxTextColor: "#332f5c",
    titleTextColor: "#FFFFFF",
  },
};

const getMuiTheme = (isDarkMode: boolean) => {
  const currentTheme = isDarkMode ? themeColors.dark : themeColors.light;
  return createTheme({
    palette: {
      mode: isDarkMode ? "dark" : "light",
      primary: { main: currentTheme.primary },
      background: {
        default: currentTheme.background,
        paper: currentTheme.cardBackground,
      },
      text: {
        primary: currentTheme.text,
        secondary: currentTheme.textSecondary,
      },
      error: { main: currentTheme.error },
    },
    typography: {
      fontFamily: "'IRANSansX', sans-serif",
      h1: { fontWeight: 700, color: currentTheme.title },
      h6: { fontWeight: 500 },
      body1: { color: currentTheme.text },
      button: { fontWeight: 700, color: currentTheme.textButton },
    },
  });
};

interface ThemeContextType {
  isDarkMode: boolean;
  theme: ThemeColors;
  toggleTheme: () => void;
  resetTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType>({
  isDarkMode: false,
  theme: themeColors.light,
  toggleTheme: () => {},
  resetTheme: () => {},
});

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProviderWrapper: React.FC<ThemeProviderProps> = ({
  children,
}) => {
  const storedTheme =
    typeof window !== "undefined" ? localStorage.getItem("theme") : null;
  const [isDarkMode, setIsDarkMode] = useState<boolean>(storedTheme === "dark");
  const resetTheme = () => {
    setIsDarkMode(false);
    localStorage.setItem("theme", "light");
  };

  useEffect(() => {
    const currentTheme = isDarkMode ? themeColors.dark : themeColors.light;
    Object.keys(currentTheme).forEach((key) => {
      document.documentElement.style.setProperty(
        `--theme-${key}`,
        currentTheme[key as keyof ThemeColors]
      );
    });
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode((prev) => {
      const newTheme = !prev;
      localStorage.setItem("theme", newTheme ? "dark" : "light");
      return newTheme;
    });
  };

  const muiTheme = useMemo(() => getMuiTheme(isDarkMode), [isDarkMode]);

  return (
    <ThemeContext.Provider
      value={{
        isDarkMode,
        theme: isDarkMode ? themeColors.dark : themeColors.light,
        toggleTheme,
        resetTheme,
      }}
    >
      <MUIThemeProvider theme={muiTheme}>
        <EmotionThemeProvider
          theme={isDarkMode ? themeColors.dark : themeColors.light}
        >
          {children}
        </EmotionThemeProvider>
      </MUIThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
